var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { t } from '@mp/locale';
import { OrderContext } from "../../hooks/OrderContext";
import PropertyFound from "./PropertyFound";
import PropertyNotFound from "./PropertyNotFound";
import emptyMap from './empty-map.png';
export default function PropertyMap(_a) {
    var address = _a.address, coveredAddress = _a.coveredAddress, notCoveredAddressLocation = _a.notCoveredAddressLocation, nextButton = _a.nextButton, inputReset = _a.inputReset, buttonDisabled = _a.buttonDisabled, inputValues = _a.inputValues, props = __rest(_a, ["address", "coveredAddress", "notCoveredAddressLocation", "nextButton", "inputReset", "buttonDisabled", "inputValues"]);
    var order = useContext(OrderContext).order;
    if (coveredAddress === 'reset' || !coveredAddress) {
        return (_jsxs("div", __assign({ className: "flexColumn" }, { children: [_jsx("p", __assign({ "data-qa": "address-empty", className: "capture-services-map-banner" }, { children: t("CAPTURE_SERVICES.SCHEDULER.ADDRESS.userMessage") })), _jsx("img", { src: emptyMap, alt: "Empty Map", className: "capture-services-empty-map" })] })));
    }
    if (coveredAddress !== 'success') {
        return (_jsx(PropertyNotFound, { searchableAddress: notCoveredAddressLocation, errorCode: coveredAddress, checkAnother: inputReset, country: null }));
    }
    var searchableAddress = {
        desc: address.description,
        lat: order.address.address_latitude,
        lng: order.address.address_longitude
    };
    return (_jsx(PropertyFound, { extendedCoverage: order === null || order === void 0 ? void 0 : order.extended_coverage, searchableAddress: searchableAddress, nextButton: nextButton, buttonDisabled: buttonDisabled }));
}
